import React from 'react';
import styled, { css } from 'styled-components';
import { getNeutralColors, getMainColor } from '../theme';
import { getColor } from '../../core/themev3';
import { ButtonText2Css, ButtonText1Css } from '../typography';

const disabledRevert = css`
  color: ${getNeutralColors('grisMedioClaro')};
  background: ${getNeutralColors('white')};
  border: 1px solid ${getNeutralColors('grisMedio')};
`;

const disabledPrimary = css`
  color: ${getNeutralColors('grisMedioClaro')};
  background: ${getNeutralColors('grisClaro')};
  border: 0;
`;

const StyledButton = styled.button`
  display: block;
  padding: ${({ padding }) => padding || '11px 12px'};
  margin: ${({ margin }) => margin || '0px'};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '12px')};
  color: ${props => getNeutralColors(props.revert ? 'black' : 'white')(props)};

  border: ${props => (props.revert ? `1px solid ${getMainColor()(props)}` : 0)};

  background: ${props => (props.revert ? getNeutralColors('white')(props) : getMainColor()(props))};

  width: 100%;
  ${props =>
    props.size === 100 &&
    css`
      ${ButtonText2Css}
      min-height: 40px;
      min-width: 40px;
    `}
  ${props =>
    props.size === 200 &&
    css`
      ${ButtonText1Css}
      min-height: 48px;
      min-width: 48px;
    `}
  :hover {
    border: ${props => (props.revert ? `1px solid ${getMainColor()(props)}` : 0)};
    background: ${props => (props.revert ? getNeutralColors('white')(props) : getMainColor()(props))};
    cursor: pointer;
  }
  ${props =>
    props.hoverColor &&
    css`
      :hover {
        background-color: ${getColor(props.hoverColor)};
      }
    `}

  :disabled {
    cursor: not-allowed;
    ${props => (props.revert ? disabledRevert : disabledPrimary)}
  }

  :disabled path {
    fill: ${getNeutralColors('grisMedioClaro')};
  }

  path {
    fill: ${props => getNeutralColors(props.revert ? 'black' : 'white')(props)};
  }
`;

const PrimaryBtn = props => {
  const {
    type,
    space,
    margin,
    children,
    dataPanel,
    size = 100,
    revert = false,
    borderRadius = false,
    hoverColor = '',
    disabled = false,
    onClick = () => {},
    as = 'button'
  } = props;

  return (
    <StyledButton
      type={type}
      size={size}
      revert={revert}
      borderRadius={borderRadius}
      disabled={disabled}
      onClick={onClick}
      as={as}
      data-panel={dataPanel || ''}
      padding={space}
      margin={margin}
      hoverColor={hoverColor}
    >
      {children}
    </StyledButton>
  );
};

export default PrimaryBtn;
